import { useState } from 'react';
import LeftIcon from '../../icon/left.svg';
import RightIcon from '../../icon/right.svg';
import moment from 'moment';
import { calendarDays } from '../../api/clientform';


interface DatePickerProps {
    dateSlots?: number[][];
    date: string;
    internalDate: string;
    setInternalDate: (date: string) => void;
    data?: calendarDays[];
    handleSetDate: (date: string) => void;
    isStageDone: boolean;
    stage: number;
    formColor: string;
}

export const DatePicker: React.FC<DatePickerProps> = (props) => {
    const { date, internalDate, setInternalDate, data, handleSetDate, dateSlots, isStageDone, stage, formColor } = props;


    const monthNames = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
    ];

    const handleDayClick = (inst: any) => {
        if (inst.target.innerHTML != '') {
            const dayOfMonth = parseInt(inst.target.innerHTML.slice(inst.target.innerHTML.length - 2, inst.target.innerHTML.length).replace('>', ''));
            const dayNumber = parseInt(inst.target.id.slice(1, inst.target.id.length));
            const momentDate = moment(internalDate);
            if (dayNumber + 1 < dayOfMonth) {
                momentDate.add(-1, 'month');
            } else if (dayNumber > dayOfMonth + 14) {
                momentDate.add(1, 'month');
            }
            momentDate.set("date", dayOfMonth);
            if (!isToday(dayNumber, dayOfMonth).includes('closed')) {
                handleSetDate(momentDate.format('YYYY-MM-DD'));
                window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            }
        }
    };

    const isToday = (dayNumber: number, dayOfMonth: number) => {
        const momentDate = moment(internalDate);
        if (dayNumber + 1 < dayOfMonth) {
            momentDate.add(-1, 'month');
        } else if (dayNumber > dayOfMonth + 14) {
            momentDate.add(1, 'month');
        }
        momentDate.set("date", dayOfMonth);
        let style = '';
        if (moment().startOf('day').isSame(momentDate)) {
            style += ' picker__element_today';
        }
        if (moment().startOf('day').isAfter(momentDate) || (data && !data[dayNumber].isAvailable)) {
            style += ' picker__element_closed';
        }
        if (moment(date).isSame(momentDate) && isStageDone) {
            style += ' picker__element_selected';
        }

        return style;
    }

    const isAnotherMonth = (dayNumber: number, dayOfMonth: number) => {
        if ((dayNumber + 1 < dayOfMonth) || (dayNumber > dayOfMonth + 14)) return ' picker__element_anothermonth'
        else return '';
    }


    return (
        <div className={`picker__container${stage == 1 ? ' picker__second' : ''}${stage == 2 ? ' picker__third' : ''}${stage == 3 ? ' picker__fourth' : ''}`} >
            <div className='picker__slide'>
                <div className='generic-date-selector__month'>
                    <div className='generic-date-selector__arrow' role='presentation' onClick={() => { setInternalDate(moment(internalDate).add(-1, 'month').format('YYYY-MM-DD')); }}>
                        <svg
                            className={'no-select'}
                            role={'presentation'}
                            style={{ color: 'red' }}
                            width="14" height="28" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 1L1 6L5 11" stroke={formColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {/* <img
                            height={'25'}
                            className={'no-select'}
                            src={LeftIcon}
                            alt={'left'}
                            role={'presentation'}
                            style={{ color: 'red' }}
                        /> */}
                    </div>
                    <div style={{color: formColor}} className='generic-date-selector__month-year'>
                        {monthNames[moment(internalDate).month()]}, {moment(internalDate).year()}
                    </div>
                    <div className='generic-date-selector__arrow' role='presentation' onClick={() => { setInternalDate(moment(internalDate).add(1, 'month').format('YYYY-MM-DD')); }}>
                        <svg
                        className={'noSelect'}
                        role={'presentation'}
                         width="14" height="28" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 11L5 6L1 1" stroke={formColor} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        {/* <img
                            height={'25'}
                            className={'noSelect'}
                            src={RightIcon}
                            alt={'right'}
                            role={'presentation'}
                        /> */}
                    </div>

                </div>
                <div className="picker__row">
                    <div className="picker__dayofweek">
                        Пн
                    </div>
                    <div className="picker__dayofweek">
                        Вт
                    </div>
                    <div className="picker__dayofweek">
                        Ср
                    </div>
                    <div className="picker__dayofweek">
                        Чт
                    </div>
                    <div className="picker__dayofweek">
                        Пт
                    </div>
                    <div className="picker__dayofweek">
                        Сб
                    </div>
                    <div className="picker__dayofweek">
                        Вс
                    </div>
                </div>
                {dateSlots?.map((element, index) => {
                    return (
                        <div key={'r' + index} className="picker__row">
                            {element.map((childElement, childIndex) => {
                                return (
                                    <div
                                        style={isToday(index * 7 + childIndex, childElement).includes('picker__element_selected') ? {backgroundColor: formColor} : {}}
                                        key={'e' + childIndex}
                                        id={'e' + (index * 7 + childIndex)}
                                        role="presentation"
                                        onClick={handleDayClick}
                                        className={`picker__element${isAnotherMonth(index * 7 + childIndex, childElement)}${isToday(index * 7 + childIndex, childElement)} no-select`}>
                                        {childElement}
                                    </div>);
                            })}
                        </div>
                    );
                })}
            </div>
        </div>);
}